<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-05-23 10:51:57
-->
<template>
  <el-drawer
    append-to-body
    ref="root"
    class="panel__notice--slide flex-col"
    :visible.sync="isVisible"
    :withHeader="false"
    @opened="handleOpened"
    @click.native.capture="handleRootClick"
    size="480px"
  >
    <div class="area__title">
      <span>消息中心</span>
      <i
        class="el-icon-close clickable use-opacity float-right"
        title="关闭"
        @click="close"
      ></i>
    </div>
    <div class="area__filter">
      <div class="row flex-row">
        <div class="flex-expend seatch-condition">
          <el-badge
            :value="selfMsgCount"
            :max="99"
            :hidden="selfMsgCount <= 0"
            style="z-index: 1"
          >
            <el-button
              :type="
                searchForm.source === MESSAGE_SOURCE.self ? 'primary' : null
              "
              size="small"
              @click="setSearchNoticeType(MESSAGE_SOURCE.self)"
            >
              我的消息
            </el-button>
          </el-badge>
          <el-badge
            :value="systemMsgCount"
            :max="99"
            class="ml-12"
            :hidden="systemMsgCount <= 0"
          >
            <el-button
              size="small"
              :type="
                searchForm.source === MESSAGE_SOURCE.system ? 'primary' : null
              "
              @click="setSearchNoticeType(MESSAGE_SOURCE.system)"
            >
              系统公告
            </el-button>
          </el-badge>
          <el-checkbox class="ml-12" v-model="searchForm.notReadOnly">
            只看未读
          </el-checkbox>
        </div>
        <el-button size="small" @click="setAllNoticeRead">
          全部标记为已读
        </el-button>
      </div>
    </div>
    <div
      ref="itemContainer"
      :class="[
        'container__notice',
        'flex-expend',
        (notices || []).length == 0 ? 'flex-center' : null,
      ]"
      v-infinite-scroll="load"
    >
      <NoticeItem
        :class="[
          'notice-item',
          lastClickedNotice === notice ? 'selected' : null,
        ]"
        v-for="notice in notices"
        :data="notice"
        :key="notice.id"
        @readed="handleNoticeReaded"
      ></NoticeItem>
      <el-empty :image-size="100" v-if="(notices || []).length == 0"></el-empty>
    </div>
  </el-drawer>
</template>

<script>
import NoticeItem from "./components/noticeItem.vue";
import { systemMessageConnector } from "../../views/common/data";
import { delay, Y_M_D_H_m } from "@/utils/dateUtils";
import { MESSAGE_SOURCE, isJump, dealJump, RedirectRouter } from "./data";
import { mapGetters } from "vuex";
import {
  fetchNotice,
  getNotReadInfo,
  setNoticeRead,
  setAllNoticeRead,
  getRefreshInfo,
} from "../../api/notice";
import "./jumpDealer";
import { genarateAvatarUrl } from "../../api/user";

const NOTICE_ITEM_MIN_HEIGHT = 56;
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NoticeItem,
  },
  data() {
    return {
      MESSAGE_SOURCE,

      isInit: false,
      systemMsgCount: 0,
      selfMsgCount: 0,

      searchForm: {
        source: MESSAGE_SOURCE.self,
        notReadOnly: false,
        courseId: null,
        pageIndex: 1,
      },
      pageSize: 10,
      notices: [],
      lastClickedNotice: null,
      systemCodes: [],
    };
  },
  methods: {
    Y_M_D_H_m,
    getSystemCodes() {
      let codes = this.getUserInfo.systemCodes;
      let systemCodes = codes.split(",");
      return systemCodes;
    },
    getLoading() {
      return this.$$loading(null, {
        target: this.$refs.root.$el.querySelector(".el-drawer"),
      });
    },
    async handleOpened() {
      this.$nextTick(() => {
        this._loadData(false, true);
      });
    },
    async _loadData(infiniteMode, initMode) {
      console.log("#-# load data?");
      let loading = this.getLoading();
      try {
        const notReadInfo = await getNotReadInfo();
        console.log("#-# @@@@", notReadInfo);
        !infiniteMode && (this.systemMsgCount = notReadInfo.system.count);
        !infiniteMode && (this.selfMsgCount = notReadInfo.self.count);

        if (initMode) {
          this.isInit = false;
          if (this.systemMsgCount > 0 && this.selfMsgCount <= 0) {
            this.searchForm.source = MESSAGE_SOURCE.system;
          } else {
            this.searchForm.source = MESSAGE_SOURCE.self;
          }
          this._setProperNoticeFetchSize();
          this.isInit = true;
        }

        let formData = { ...this.searchForm, pageSize: this.pageSize };
        if (infiniteMode && this.notices.length > 0) {
          formData = {
            ...formData,
            previewsTimeSpan: this.notices.$$last().ts,
            previewsId: this.notices.$$last().id,
          };
        }
        console.log("#-# formData", formData, this.pageSize);
        let notices = await fetchNotice(formData);
        notices = (notices || {}).records || [];
        notices.forEach((n) => {
          if (!n.senderPortrait) return;
          n.senderPortrait = genarateAvatarUrl(n.senderPortrait);
        });
        console.log("#-# notices", notices);
        if (infiniteMode) {
          this.notices.push(...notices);
        } else {
          this.notices = notices;
        }
      } catch (err) {
        console.log(err);
        this.$$error(err);
      } finally {
        loading && loading.close();
      }
    },
    load() {
      console.log("#-# raise a new infinate load!");
      if (!this.isInit) return;
      this._loadData(true, false);
    },
    setSearchNoticeType(source) {
      console.log("#-# set search notice type", source, this.searchForm);
      if (source != this.searchForm.source) {
        this.searchForm.source = source;
      }
    },
    async setAllNoticeRead() {
      if (this.systemMsgCount == 0 && this.selfMsgCount == 0) {
        this.$$flash("暂无未读消息。", "warning");
        return;
      }

      let loading = this.getLoading();
      try {
        await setAllNoticeRead();
        this.$$flash("已将所有消息标记为已读。", "success");
        this.notices.$$each((n) => (n.hasRead = true));
        this.systemMsgCount = this.selfMsgCount = 0;
        loading.close() && (loading = null);
      } catch (error) {
        this.$$error(error);
      } finally {
        loading && loading.close();
      }
    },
    close() {
      this.isVisible = false;
    },
    async handleNoticeReaded(notice) {
      this.lastClickedNotice = notice;
      if (notice.hasRead) return;
      try {
        const setReaded = await setNoticeRead({ id: notice.id });
        console.log("#-# has read", setReaded);
        if (setReaded && !notice.hasRead) {
          notice.hasRead = true;
        }
      } catch (error) {
        this.$$error(error);
      }
    },
    _getNoticeRange() {
      return {
        source: this.searchForm.source,
        start: this.notices.length ? this.notices[0].ts : 0,
        startId: this.notices.length ? this.notices[0].id : null,
        end: this.notices.length ? this.notices.$$last().ts : 0,
        endId: this.notices.length ? this.notices.$$last().id : null,
      };
    },
    async refreshNoticeInfo(ev) {
      console.log("#-# notice reached!", ev);
      const dataForm = this._getNoticeRange();
      if (dataForm.start <= 0) {
        this._loadData(false, this.isInit);
        return;
      }

      const refreshData = await getRefreshInfo(dataForm);
      const newNoticeRange = this._getNoticeRange();
      if (
        newNoticeRange.start != dataForm.start &&
        newNoticeRange.end != dataForm.end
      ) {
        setTimeout(() => {
          this.refreshNoticeInfo();
        }, 100);
      } else {
        console.log("#-# msg reached");
        this.systemMsgCount = refreshData.system.count;
        this.selfMsgCount = refreshData.self.count;

        const notReadNoticeWithSelectedType = (
          refreshData.notReadNoticeIds || []
        ).filter((n) => n.source === this.searchForm.source);
        if (notReadNoticeWithSelectedType.length) {
          const noticeMap = new Map();
          for (const notice of this.notices) {
            noticeMap.set(notice.id, notice);
          }

          for (const nid of notReadNoticeWithSelectedType) {
            const existNotice = noticeMap.get(nid);
            if (!!existNotice) {
              existNotice.hasRead = false;
              noticeMap.delete(nid);
            }
          }
          for (const leftNotice of noticeMap.values()) {
            leftNotice.hasRead = true;
          }
        }

        const newAddedNoticesWithSelectedType = (
          refreshData.newAddedNotices || []
        ).filter((n) => n.source === this.searchForm.source);
        if (newAddedNoticesWithSelectedType.length > 0) {
          this.notices.splice(0, 0, ...newAddedNoticesWithSelectedType);
        }
      }
    },
    handleRootClick(ev) {
      const ele = ev.target;
      if (isJump(ele)) {
        const routerWrapper = new RedirectRouter(
          this.$router,
          this.$route.name
        );
        dealJump(ele, routerWrapper);
        this.isVisible = false;
      }
    },
    _setProperNoticeFetchSize() {
      const itemContainerHeight = this.$refs.itemContainer.clientHeight;
      const pageSize =
        Math.floor(itemContainerHeight / NOTICE_ITEM_MIN_HEIGHT) + 1;
      this.pageSize = Math.max(10, pageSize);
    },
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    searchForm: {
      handler(newVal, oldVal) {
        if (!this.isInit) return;
        this.$nextTick(() => {
          console.log("#-# here?");
          this._setProperNoticeFetchSize();
          this._loadData();
        });
      },
      deep: true,
    },
  },
  mounted() {
    systemMessageConnector.addEventListener(
      "noticeReached",
      this.refreshNoticeInfo
    );
    systemMessageConnector.addEventListener(
      "noticeRead",
      this.refreshNoticeInfo
    );
    systemMessageConnector.addEventListener("downloadCompleted", (args) => {
      console.log("#-# download completed", args);
    });
  },
};
</script>

<style lang="scss">
.panel__notice--slide {
  .area__title {
    padding: 12px;
    color: #333;
    font-size: 16px;
    border-bottom: 1px solid #dcdfe6;
  }

  .area__filter {
    padding: 12px;
    border-bottom: 1px solid #dcdfe6;

    .row {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .row-title {
        display: inline-block;
        font-size: 14px;
        width: 40px;
      }

      .fill-all-left-width {
        width: calc(100% - 40px);
      }
    }
  }

  .notice-item {
    border-bottom: 1px solid #dcdfe6;
    &.selected {
      background: #fff7b8;
    }
  }
  .container__notice {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .rtl {
    text-align: left;
    direction: ltr;
  }

  .el-drawer__body {
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>